import { makeStyles } from '@material-ui/core/styles';

const creditCardStyles = makeStyles((Theme) => ({
  creditCardTitle: {
    display: 'flex',
    fontSize: Theme.typography.size[4],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    marginBottom: '10px',
    borderBottom: `1px solid ${Theme.palette.gray[250]}`,
    paddingBottom: '25px',
    '& > span svg': {
      color: Theme.palette.primary.light,
      width: '16px',
      height: '16px',
      marginTop: '4px',
      marginLeft: '6px',
    },
  },
  creditCardLabelCharged: {
    fontSize: Theme.typography.size[3],
    lineHeight: '22px',
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.regular,
    marginBottom: '30px',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
      lineHeight: '19px',
    },
  },
  buttonHide: {
    display: 'none',
  },
  cardContainerCheckoutPayment: {
    marginLeft: '0',
    marginRight: '0',
    [Theme.breakpoints.down('sm')]: {
      marginBottom: '30px',
    },
  },
  totalPaymentsHaveBeenMet: {
    color: Theme.palette.green,
    fontFamily: Theme.typography.base.semiBold,
    lineHeight: '20px',
  },
  creditCardForm: {
    marginTop: '30px',
  },
  elevation: {
    boxShadow: '0px 2px 4px rgba(6, 21, 86, 0.15)',
    borderRadius: '4px',
  },
}));

export default creditCardStyles;
